import Vue from 'vue';

Vue.component('homepage-car-showcase', {
    data() {
        return {
            tabIndex: 999,
        };
    },

    mounted() {
        this.draggable();
    },

    methods: {
        switchTab(index) {
            if (index != this.tabIndex) {
                this.tabIndex = index;
            }
            setTimeout(() => this.draggable(), [500]);
        },

        draggable() {
            const slider = document.querySelector(
                '.carshowcase__content-wrapper',
            );
            let isDown = false;
            let startX;
            let scrollLeft;
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
            });
            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 1.5;
                slider.scrollLeft = scrollLeft - walk;
            });
        },

        setAllModels() {
            if (this.tabIndex !== 999) {
                this.tabIndex = 999;
            }
            setTimeout(() => this.draggable(), [500]);
        },
    },
});
